module.exports = __webpack_public_path__ + "static/img/game-logo-tvbet.956d4de.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-tvbet.png
// module id = GOWb
// module chunks = 0 1 2 3 4 5 6